var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 79,
    viewBox: "0 0 60 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6571 73.2728L27.7971 73.5428L27.9571 74.9128L27.7771 75.5728L25.8271 78.0928L29.8471 75.6728L28.6571 73.2728Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2371 71.8828L30.1271 71.9528L30.2771 73.3228L30.5971 73.9228L33.0771 75.9328L28.6171 74.4828L29.2371 71.8828Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4972 35.1228L21.9172 55.9128L27.7172 74.8428L29.4672 74.0328L26.4472 57.1928L32.7772 35.7628L22.4972 35.1228Z",
    fill: "#193F3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4172 36.1028L30.4872 56.3728L28.4172 73.2228H30.4872L34.5772 56.1228L38.2872 35.1228L28.4172 36.1028Z",
    fill: "#193F3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46715 2.95277C2.46715 2.95277 1.82715 0.262774 1.22715 0.0527741C0.627148 -0.157226 -1.33285 0.122774 1.46715 3.46277L2.46715 2.95277Z",
    fill: "#FFC190"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1971 13.9128L9.36713 17.9128L1.18713 3.36277L2.38713 2.60277L10.3871 12.8428L21.0971 9.84277C21.0971 9.84277 24.6171 8.54277 25.2971 10.9628C24.1811 12.2544 22.7765 13.265 21.1971 13.9128Z",
    fill: "#FFC7CA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1771 15.3928L49.8571 19.8628L58.5571 5.60277L57.3871 4.82277L49.0271 14.7328L38.4271 11.3128C38.4271 11.3128 34.9571 9.88277 34.1871 12.3128C35.2593 13.636 36.6255 14.6907 38.1771 15.3928Z",
    fill: "#FFC7CA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9171 38.2228L38.8671 36.7628L37.4871 24.2928L40.7871 11.8828L33.2671 9.26277H21.4471L21.9871 26.4628L21.9171 38.2228Z",
    fill: "#46CDC5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6371 6.32277L29.1271 9.66277C29.1271 9.66277 33.4571 12.1028 32.8771 10.5228C32.4304 9.06522 32.0698 7.58266 31.7971 6.08276L29.6371 6.32277Z",
    fill: "#FFC190"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2271 2.60276C29.0271 3.30276 28.6471 4.65276 29.1171 5.48276C29.5871 6.31276 30.3271 7.82276 31.3671 8.09276C31.5512 8.12883 31.7405 8.12783 31.9241 8.08982C32.1078 8.05181 32.282 7.97756 32.4366 7.8714C32.5911 7.76524 32.723 7.62931 32.8244 7.47158C32.9258 7.31384 32.9947 7.13746 33.0271 6.95276C33.2071 6.27276 33.0271 2.63276 31.3171 1.95276C30.0271 1.39276 29.3671 2.05276 29.2271 2.60276Z",
    fill: "#FFC190"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0272 2.52276C31.8053 2.76291 31.5279 2.945 31.2193 3.05309C30.9108 3.16118 30.5804 3.19197 30.2572 3.14276C29.1072 2.99276 29.3672 4.07276 29.3872 4.19276C29.4072 4.31276 29.7672 5.86276 29.3872 5.93276C29.0072 6.00276 28.2772 4.10276 28.6972 2.73276C28.8144 2.39635 29.0283 2.10202 29.3121 1.88664C29.5959 1.67126 29.9369 1.54441 30.2924 1.52199C30.648 1.49957 31.0022 1.58257 31.3108 1.76059C31.6194 1.93861 31.8686 2.20374 32.0272 2.52276Z",
    fill: "#2E3B57"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6971 6.48277C30.3767 7.00915 31.2316 7.25598 32.0871 7.17277C32.8171 7.00277 33.0871 5.68277 33.0171 5.40277C32.9471 5.12277 33.6471 7.80277 32.0171 8.07277C30.3871 8.34277 29.6971 6.48277 29.6971 6.48277Z",
    fill: "#2E3B57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2972 5.12277C57.2972 5.12277 58.0372 2.45277 58.6472 2.27277C59.2572 2.09277 61.1972 2.43277 58.2772 5.67277L57.2972 5.12277Z",
    fill: "#FFC190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanShape);
export default __webpack_public_path__ + "static/media/human-shape.25c38a10ffb63002f9d752fa942e0103.svg";
export { ForwardRef as ReactComponent };